<app-top-footer-ch1 *ngIf="!chTheme4 && !chTheme6 && !chTheme8 && !chTheme13 && !chTheme14 && !chTheme15"  [footerdata]="footerdata"
  [footerwarning]="footerwarning"
  (linkClick)="onClickLinks($event.event, $event.navLink, $event.navname)"  [showContactDetails]="showContactDetails"
  [isExternal]="isExternal.bind(this)"></app-top-footer-ch1>

  <app-top-footer-ch4 *ngIf="chTheme4 || chTheme6  || chTheme8 || chTheme13 || chTheme14 || chTheme15" [footerdata]="footerdata"
  [footerwarning]="footerwarning"
  (linkClick)="onClickLinks($event.event, $event.navLink, $event.navname)" [showContactDetails]="showContactDetails"
  [isExternal]="isExternal.bind(this)"></app-top-footer-ch4>

  
